module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/validation/validation.component.scss
// module id = ./src/app/validation/validation.component.scss
// module chunks = main